var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortedOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.869507,
    y: 0.739258,
    width: 45.6788,
    height: 45.6788,
    rx: 15,
    fill: "#C824E2",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1074 15.4344C27.5282 10.8552 20.0137 10.8552 15.4345 15.4344C10.8553 20.0136 10.8553 27.5281 15.4345 32.1073C20.0137 36.6865 27.4108 36.6865 31.99 32.1073C36.6866 27.5281 36.6866 20.0136 32.1074 15.4344ZM17.0783 17.0782C20.4833 13.6732 25.767 13.4383 29.5243 16.2563L16.3738 29.5242C13.4385 25.8843 13.7907 20.4832 17.0783 17.0782ZM18.0176 31.168L31.1681 18.0175C33.986 21.6574 33.7512 27.0585 30.3462 30.4635C26.9412 33.8685 21.6575 34.1033 18.0176 31.168Z",
    fill: "#C824E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortedOut);
export default __webpack_public_path__ + "static/media/sorted_out.6128d3dd.svg";
export { ForwardRef as ReactComponent };